import { defineComponent } from "vue";
import BaseFooter from "@/components/Shared/BaseFooter/BaseFooter.vue";
import ThemesHelper from "@/helpers/ThemesHelper";
import LogoClinicarx from "@/assets/themes/clinicarx-logo-white.svg";

export default defineComponent({
  components: {
    BaseFooter,
  },
  data() {
    return {
      logoPath: LogoClinicarx,
      testName: ThemesHelper.getThemeParams("testName"),
    };
  },
});
